/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryPeerToPeerIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.04338 14.2748C6.14214 14.2917 3.93652 16.684 3.93652 19.67C3.93652 19.67 3.97045 20.3657 3.98742 20.3826H4.00438L9.56934 20.0942C10.0783 20.0942 10.4346 20.0942 10.4516 20.3657C10.4686 20.6541 10.0783 20.7389 9.7899 20.7559L4.02135 21.4006C3.64809 21.4006 2.91854 21.2649 2.91854 20.0942C2.90157 16.0053 5.53135 13.2398 9.04338 13.2228C10.3328 13.2228 11.3847 13.6131 12.3688 14.1899C12.8099 14.4444 13.0135 14.7159 12.8608 14.9534C12.7251 15.1909 12.2161 14.9195 11.9786 14.7837C11.1811 14.3596 10.1801 14.2748 9.04338 14.2748Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.02644 5.41832C7.10924 5.41832 5.54834 6.97922 5.54834 8.89642C5.54834 10.8136 7.10924 12.3745 9.02644 12.3745C10.9436 12.3745 12.5045 10.8136 12.5045 8.89642C12.5215 6.96226 10.9606 5.40135 9.02644 5.41832ZM9.0434 11.4923C7.61823 11.4923 6.44756 10.3386 6.44756 8.89642C6.44756 7.47124 7.60127 6.30057 9.0434 6.30057C10.4686 6.30057 11.6393 7.45428 11.6393 8.89642C11.6393 10.3216 10.4855 11.4753 9.0434 11.4923Z"
      fill="currentColor"
    />
    <path
      d="M17.3908 14.5122C14.1503 14.5122 11.6223 17.0911 11.6392 20.3656V20.7898C11.6392 21.3327 11.8937 21.6551 12.3349 21.6551L22.4977 20.9255C22.6843 20.9255 22.854 20.8576 22.9728 20.7389C23.1254 20.5862 23.1933 20.3487 23.1763 20.0602V19.6361C23.1763 16.5482 20.835 14.5122 17.3908 14.5122Z"
      fill="currentColor"
    />
    <path
      d="M17.4925 13.4773C19.3197 13.4773 20.8009 11.9961 20.8009 10.1689C20.8009 8.34171 19.3197 6.86047 17.4925 6.86047C15.6653 6.86047 14.1841 8.34171 14.1841 10.1689C14.1841 11.9961 15.6653 13.4773 17.4925 13.4773Z"
      fill="currentColor"
    />
  </svg>
);
